import { createStore } from 'zustand/vanilla';
// Slice Creators
export const createMFInfoSlice = (set) => ({
    mfInfo: {
        domain: '',
        name: '',
        version: ''
    },
    setMFInfo: (info) => set((state) => ({
        mfInfo: { ...state.mfInfo, ...info }
    })),
});
export const createShellInfoSlice = (set) => ({
    shellInfo: {
        version: '',
        cdn: ''
    },
    setShellInfo: (info) => set((state) => ({
        shellInfo: { ...state.shellInfo, ...info }
    })),
});
export const createUserSlice = (set, get) => ({
    user: undefined,
    setUser: (user) => set({ user }),
    clearUser: () => set({ user: undefined }),
    userDisplayName: () => {
        const user = get().user;
        return (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email) || 'Anonymous';
    },
});
export const createThemeSlice = (set, get) => ({
    theme: 'light',
    setTheme: (theme) => set({ theme }),
    toggleTheme: () => set({ theme: get().theme === 'light' ? 'dark' : 'light' }),
});
export const createLoadingSlice = (set, get) => ({
    loading: {},
    setLoading: (key, isLoading) => set((state) => ({
        loading: { ...state.loading, [key]: isLoading }
    })),
    clearAllLoading: () => set({ loading: {} }),
    isAnyLoading: () => Object.values(get().loading).some(Boolean),
});
export const createDataSlice = (set, get) => ({
    data: {},
    setData: (key, value) => set((state) => ({
        data: { ...state.data, [key]: value }
    })),
    getData: (key) => get().data[key],
    clearData: (key) => set((state) => {
        const { [key]: _, ...rest } = state.data;
        return { data: rest };
    }),
    clearAllData: () => set({ data: {} }),
});
export const createCounterSlice = (set, get) => ({
    counter: 0,
    setCounter: (count) => set({ counter: count }),
    incrementCounter: () => set({ counter: get().counter + 1 }),
    decrementCounter: () => set({ counter: get().counter - 1 }),
});
export const createLogsSlice = (set) => ({
    logs: [],
    _setLogs: (logs) => set({ logs }),
});
/**
 * Global state store - singleton instance shared across all MFs
 */
export const globalStateStore = createStore()((...a) => ({
    ...createMFInfoSlice(...a),
    ...createShellInfoSlice(...a),
    ...createUserSlice(...a),
    ...createThemeSlice(...a),
    ...createLoadingSlice(...a),
    ...createDataSlice(...a),
    ...createCounterSlice(...a),
    ...createLogsSlice(...a),
}));
